var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.854,
    height: 25.832,
    viewBox: "0 0 25.854 25.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(-2644.329 -110.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M2663.772,134.763l.814,1.614-5.177-1.226,2.475-3.8.817,1.39a10.4,10.4,0,0,0,5.236-8.233,10.1,10.1,0,0,0-4.942-10.02c-4.425-2.743-8.749-2.139-12.851.989l-1.4-1.555c4.821-4.778,13.3-4.308,18.107.9A13.047,13.047,0,0,1,2663.772,134.763Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M2663.205,123.063v1.425c-1.405,0-2.772-.032-4.136.017a4.375,4.375,0,0,0-1.443.364,1.318,1.318,0,0,1-1.721-.352,1.245,1.245,0,0,1,.163-1.728,1.71,1.71,0,0,0,.367-1.025c.032-2.252.017-4.5.017-6.821l.867-.063a3.68,3.68,0,0,1,.068.485c0,2.135,0,4.27.005,6.4,0,.983.3,1.285,1.31,1.29C2660.189,123.069,2661.675,123.063,2663.205,123.063Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M2644.562,120.64l2.1-4.679,1.8,1.279-1.746,4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M2646.872,126.052l-2.035.971-.508-3.874h2.209Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M2647.336,127.587l1.728,2.832-1.648,1.441-1.916-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M2652.637,135.606l-3.077-1.7,1.273-1.812,2.611,1.471Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M2658.36,136.439l-3.246-.157.332-2.086C2657.583,133.919,2657.879,134.132,2658.36,136.439Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.976bce0a5e992d2564b425254374e0a7.svg";
export { ForwardRef as ReactComponent };